import { useNavigate } from "react-router";
import { deviceLabel, deviceStatusLabel, isDeviceOnline, useActiveDevice, type Device } from "../shared/devices/devices.ts";
import { useSession } from "../shared/session/SessionProvider.tsx";
import { ArrowForwardIcon } from "../shared/ui/icons.tsx";
import styles from "./ActiveDeviceChip.module.css";

export function ActiveDeviceChip() {
  const { active } = useActiveDevice();
  const { user } = useSession();
  const navigate = useNavigate();
  if (!active) return null;
  const label = deviceLabel(active, user?.id);
  return (
    <button type="button" className={styles.chip} aria-label={`Активная E-va: ${label}, ${deviceStatusLabel(active)}`} onClick={() => navigate("/eva")}>
      <span className={styles.chipText}><span className={styles.chipName}>{label}</span><Status device={active} /></span>
      <ArrowForwardIcon className={styles.chipIcon} />
    </button>
  );
}
function Status({ device }: { device: Device }) {
  return <span className={`${styles.chipStatus} ${isDeviceOnline(device) ? styles.online : styles.offline}`}>{deviceStatusLabel(device)}</span>;
}
